import Env from '../Env';
import { getLocale } from '../Translate';
// const fetch = require('node-fetch');
// const crypto = require('crypto');
const querystring = require('querystring');

// const generateAuthParams = (_method, key, secret, _params = {}) => {
//     const method = _method ? _method.toUpperCase() : 'GET';

//     const nonce = Date.now();
//     let params = Object.assign({}, _params, {nonce, key});

//     let sign_str;
//     if (method === 'POST') {
//         sign_str = JSON.stringify(params) + secret;
//     } else {
//         sign_str = [].concat(secret, Object.keys(params).map(key => params[key])).filter(value => value !== undefined).sort().join('-');
//     }

//     const signature = crypto.createHash('SHA256').update(sign_str).digest('hex');
//     return Object.assign({}, params, {signature});
// }

// const decodeToken = () => {
//     let encodedJsonString = GeckoStore.local.get('token');
//     let decodedJsonString = window.atob(encodedJsonString);
//     let jsonData = JSON.parse(decodedJsonString);

//     return jsonData;
// }

const regionUrl = (token) => {
    if (window) {
        const env = Env();
        // GeckoEngage
        if (window.location.host.indexOf('geckoengage') !== -1) {
            return 'https://api.geckoform.com';
        // Gecko (stage)
        } else if (env === 'stage') {
            return 'https://api-stage.geckoform.com';
    //     // Gecko (live)
        } else if (env === 'prod') {
            return 'https://api.geckoform.com';
        // Gecko (dev)
        } else if (env === 'local') {
            return 'http://localhost:8000';
        }
    // In App
    } else {
       return 'https://api.geckoform.com';
    }
}

export default class EngageRequest {
    static delete(_endpoint, _params={}) {
        return EngageRequest.call(_endpoint, _params, 'DELETE');
    }
    static post(_endpoint, _params={}) {
        return EngageRequest.call(_endpoint, _params, 'POST');
    }

    static get(_endpoint, _params={}) {
        return EngageRequest.call(_endpoint, _params, 'GET');
    }

	static call(_endpoint, _params={}, method="GET") {
        if(!_endpoint) { return Promise.reject(new Error('No endpoint provided to make a request to')) }

        const region_url = regionUrl();

        const params = _params;
        // If we are doing a POST request just add the signature as a URL param otherwise add all of the params
        const endpoint = `${region_url}${_endpoint}?${querystring.stringify(method === 'POST' ? {signature: params.signature} : params)}`;
        // If we pass the signature up as a body parameter Engage will reject it
        if(method === 'POST') { delete params.signature; }
        return fetch(endpoint, {
            method: method,
            body: method === 'POST' ? JSON.stringify(params) : undefined,
            headers: {
                'Accept': 'application/json',
                'Content-Type': method === 'POST' ? 'application/json' : undefined,
                'Accept-Language': getLocale()
                // 'Gecko-Account': this.integration.configuration.engage_account_id,
                // 'Gecko-User': this.integration.configuration.engage_user_id,
            }
        })
        .then(res => {
            if(res.status === 200) { return res.json(); } // If the request was successful then JSON decode it and return
            return res.json().then(err => { throw new Error(err.message); }) // Otherwise throw an error based off the response
        })
    }
}